import { cn } from '@/client/lib/utils';
import { useWizard } from './wizard-context';
import type { WizardStepWrapperProps } from './types';

/**
 * Wrapper component for individual wizard steps.
 * Only renders children when this step is active.
 */
export function WizardStep({ stepId, children, className }: WizardStepWrapperProps) {
  const { steps, currentStep } = useWizard();

  // Find the index of this step by ID
  const stepIndex = steps.findIndex((s) => s.id === stepId);

  // Only render if this is the current step
  if (stepIndex !== currentStep) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex-1 overflow-y-auto animate-in fade-in slide-in-from-right-2 duration-200',
        className
      )}
    >
      {children}
    </div>
  );
}
